import styled from "styled-components";
import React from "react";
import { MaterialIcon } from "./MaterialIcon";

export const Topbar = ({breacrumb, children}) => {
    return (
        <StyledTopbar>
            <div className="breadcrumb">
                <span>InfraHub</span>
                {
                    breacrumb.map((b, i) =><React.Fragment key={i}><MaterialIcon name='keyboard_arrow_right' weight={300}/><span>{b}</span></React.Fragment>)
                }

            </div>
            <div className="topbarChildren">
                {children}
            </div>
        </StyledTopbar>
    )
}

const StyledTopbar = styled.div`
    border-bottom: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
    padding-top: ${({theme}) => theme.spacing.md};
    padding-bottom: ${({theme}) => theme.spacing.md};
    padding-left: ${({theme}) => theme.spacing.xl};
    padding-right: ${({theme}) => theme.spacing.xl};
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${({theme}) => theme.spacing.xl};

    div.breadcrumb
    {
        gap: ${({theme}) => theme.spacing.md};
        display: flex;
        align-items: center;

        span
        {
            font-weight: 400;
            color: ${({theme}) => theme.colors.mutedForeground};
        }

        span:last-child
        {
            font-weight: 500;
            color: ${({theme}) => theme.colors.neutralSecondaryForeground};
        }
    }

    div.topbarChildren
    {
        display: flex;
        gap: ${({theme}) => theme.spacing.md};
    }
`

